// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25ocV","controls":"styles_controls__3mBt5","charLimit":"styles_charLimit__1WTnA","input":"styles_input__3hP-7","send":"styles_send__DF1AI"};